<template>
<div>
    <div v-if="loading" class="loader">
        <v-progress-circular
            :size="80"
            :width="8"
            color="#6FB793"
            indeterminate
        ></v-progress-circular>         
    </div>

    <div v-else class="querytype-con">
        <div class="flex query-con">
        <div class="query" v-for="(item, index) in queryTypes" :key = index>
            <div class="flex query-header">
                <p class="qtitle">{{item.name}}</p>
                <p @click="handleSelectall(item.topics)" class="selectall">Select all</p>
            </div>
            <div class="topics" v-for="(topic, topicindex) in item.topics" :key = topicindex>
                <div>
                    <v-checkbox 
                        v-model="selectedTopics"
                        color="success"
                        :label="topic.name"
                        :value = topic.id
                    />
                </div>
            </div>
        </div> 
        </div>

        <div class="flex filter-buttons">
            <button @click="handleClearBtn" class="clear">Clear</button>
            <button @click="handleDoneBtn" class="done">Done</button>
        </div> 
    </div>

</div>
</template>


<script>
import API_URL from "../../../../helpers/apiUrls";
import { mapActions } from "vuex";

export default {
    name : "queryType",
    ...mapActions(["queryStore", "removealltopics", "GET_SELECTED_TOPICS", "GET_SELECTED_CROPS"]),
    data(){
        return{
            queryTypes : [],
            qtypename : [],
            selected: false,
            selectedTopics : [],
            croptypeid : [],
            isCroppresent : false,
            loading : false,
            isCropSelected : false,
        }
    },
    mounted(){
        console.log("Q TYPE MOUNTED");
        this.selectedTopics = []
        this.getQuerytype();
        this.getselectedTopics();
    },

    watch:{
        selectedTopics:function(){       
            // this.checkcropidpresent();
            // this.checkCropExistInStore()
            // if(!this.isCroppresent){
            //     this.$store.dispatch('queryStore/removeallcrops');
            // }
        },
    },

    methods:{
        checkCropExistInStore(){
            const selectedCropCount = this.$store.getters["queryStore/GET_SELECTED_CROPS"];
            if(selectedCropCount.length > 0){
                this.isCropSelected = true;
            } 

            if(!this.isCroppresent && this.isCropSelected){
                this.$store.dispatch('queryStore/removeallcrops');
            }
        },

        // get the ids of crops
        getCropId(){
            this.queryTypes.map(item=>{
                if(item.name === "Crop"){
                    item.topics.map(topic => {
                        this.croptypeid.push(topic.id)
                    })
                }
            })
        },

        // select all the topics
        handleSelectall(selecteditem){   
            console.log("SELECTED ITEM", selecteditem); 
            const selectall = []        
            selecteditem.map(item => {
                selectall.push(item.id)
            })
            this.selectedTopics = [...this.selectedTopics, ...selectall]
        },

        // check if seleted item is crop or not
        checkcropidpresent(){
            var flag = true;
            for(var i = 0; i<this.selectedTopics.length; i++){
                for(var j = 0; j<this.croptypeid.length; j++){
                    if(this.selectedTopics[i] === this.croptypeid[j]){
                        this.isCroppresent = true;
                        flag = false;
                    }
                }
            }
            if(flag){
                this.isCroppresent = false;
            }
        },

        handleClearBtn(){
            this.selectedTopics = []
            this.isCropSelected = false;
            this.$store.dispatch('queryStore/removealltopics');
            this.$store.dispatch('queryStore/removeallcrops');
            this.$emit('clearquerytype')
        },
        handleDoneBtn(){
            this.checkcropidpresent();
            const uniqueSelectedTopics = this.selectedTopics.filter(function(item, i, ar){ return ar.indexOf(item) === i; });
            this.$store.dispatch('queryStore/addtopics', { topics: uniqueSelectedTopics}); 
            this.$emit('croptypeclicked', this.isCroppresent)
            this.$emit('applyquerytype')
        },

        // get selected topics from store
        getselectedTopics(){
            this.selectedTopics = this.$store.getters["queryStore/GET_SELECTED_TOPICS"];
        },

        // get all the query type intial call
        getQuerytype(){
            this.loading = true;
            const successHandler = (response) => {
                if (response.status === 200) {
                    this.loading = false;
                    this.queryTypes = response.data.entries;
                    this.getCropId();
                }
            };

            const errorHandler = (error) => {
                this.showToast(
                    this.loading = false,
                    "Something went wrong internally!",
                    "error",
                    10000
                );
                console.log(error);
                this.toggleLoader(false);
            };

            this.requestGET(
                `${API_URL.getTagHierarchy}`,
                {},
                {},
                successHandler,
                errorHandler,
            );             
        }
    }
}
</script>


<style lang="scss" scoped>
.loader{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 470px;
    background-color: #ffffff;

}
.query-con{
    border: 0.5px solid #BFBFBF;
    border-radius: 10px;
    padding: 20px;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    padding-bottom: 20px;
    max-height: 370px;
    overflow: scroll;
    overflow-x: hidden;
    padding-top: 100px;
}
.query{
    width: 100%;
    margin-top: 10px;
}
.querytype-con{
    background-color: #FFFFFF;
    width: 100%;
    padding: 20px;
}
.query-header{
    width: 96%;
    justify-content: space-between;

    p{
        margin-bottom: 0px;
    }
}
.topics{
    text-align: left;
}
.selectall{
    color: #328736;
    font-weight: 500;
    font-size: 14px ;
    cursor: pointer;
}
.filter-buttons{
    width: 100%;
    column-gap: 20px;
    margin-top: 10px;

    button{
        padding: 15px 20px;
        border-radius: 5px;
        font-size: 0.8rem;
        font-weight: 500;
    }
}
.clear{
    background-color: rgba(57, 186, 123, 0.11);
    width: 50%;
    color: #328736;
}
.done{
    background-color: #36983B;
    width: 50%;    
    color: #fff;
}
.qtitle{
    color: #5B5B5B;
    font-weight: 500;
    font-size: 16px;   
}
.v-input--selection-controls {
    margin-top: 6px;
    padding-top: 4px;
}
</style>

<style>
.v-input__slot{
    margin-bottom: 0px !important;
}
.v-messages{
    display: none !important; 
}
</style>